export default class CkPlugin {
    constructor(name) {
        this.name = name;
        this.nodeElement = this.createNode();
    }

    createNode() {

    }

    node() {
        return this.nodeElement;
    }
}